const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNopayments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.98521 3.29502H21.1552C22.2652 3.29502 23.1552 4.18502 23.1552 5.29502V17.295C23.1552 17.635 23.0752 17.955 22.9252 18.235L21.1552 16.465V11.295H15.9852L11.9852 7.29502H21.1552V5.29502H9.98522L7.98521 3.29502ZM21.6452 22.605L18.3252 19.295H5.15521C4.04521 19.295 3.15521 18.405 3.15521 17.295L3.16521 5.29502C3.16521 4.95502 3.24521 4.63502 3.39521 4.36502L1.84521 2.80502L3.25521 1.39502L23.0552 21.195L21.6452 22.605ZM5.15521 6.12502V7.29502H6.32521L5.15521 6.12502ZM16.3252 17.295L10.3252 11.295H5.15521V17.295H16.3252Z",
    fill: props.fill
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNopayments);
export default __webpack_public_path__ + "static/media/ic_nopayments.3a151e6430d1c59e0c457d39a1eb1556.svg";
export { ForwardRef as ReactComponent };